
import React from "react";

const ReloadIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_681_29698)">
                <path d="M20 11C19.7554 9.24022 18.9391 7.60966 17.6766 6.3595C16.4142 5.10933 14.7758 4.30892 13.0137 4.08155C11.2516 3.85419 9.46362 4.21248 7.9252 5.10125C6.38678 5.99001 5.18325 7.35994 4.5 9M4 5V9H8" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 13C4.24456 14.7598 5.06093 16.3903 6.32336 17.6405C7.58579 18.8907 9.22424 19.6911 10.9863 19.9184C12.7484 20.1458 14.5364 19.7875 16.0748 18.8988C17.6132 18.01 18.8168 16.6401 19.5 15M20 19V15H16" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_681_29698">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ReloadIcon;
